import { useAppSelector } from "redux/hooks";
import * as s from "./SideNavBarStyled";
import * as mediaQuery from "components/MediaQuery";
import TopInfo from "./TopInfo";
import MenuComponent from "./Menu";
import CLOSE_MOBILE_ICON from "assets/icons/cross.svg";
import COLLAPSE_ICON from "assets/icons/sidenav/collapse.svg";
import HAMBURGER_ICON from "assets/icons/hamburger.svg";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";

import { Sidebar, useProSidebar } from "react-pro-sidebar";
import { useEffect } from "react";
import * as MediaQuery from "components/MediaQuery";
import { useSelector } from "react-redux";
import { selectStomp } from "redux/stomp/stompSelector";

type Props = {
  top?: number;
};
const themes = {
  light: {
    sidebar: {
      backgroundColor: COLORS.WHITE,
      color: "#607489",
      borderColor: LIGHT_THEME_COLORS.LIGHTGRAYBORDER,
      boxShadow: `rgba(100, 100, 111, 0.2) 0px 7px 29px 0px`,
    },
  },
  dark: {
    sidebar: {
      backgroundColor: COLORS.SIDEBARBG,
      color: COLORS.WHITE,
      border: "none",
    },
  },
};

function SideNavBar(props: Props): JSX.Element {
  const { collapseSidebar, collapsed } = useProSidebar();
  const theme = useAppSelector((state) => state.theme.theme);
  const isMobile = MediaQuery.useIsMobile();

  useEffect(() => {
    if (collapsed && isMobile) {
      collapseSidebar();
    }
  }, []);
  const { connected } = useSelector(selectStomp);

  return (
    <>
      {!collapsed && (
        <mediaQuery.Mobile>
          <s.SidebarBG>
            <s.SideBarContainer isCollapsed={collapsed} top={props.top}>
              <s.TopButtonWrapper>
                <s.CollapseButton
                  onClick={() => collapseSidebar()}
                  data-testid="blocks-sidenav-sidenav-collapse-close-open"
                >
                  <img
                    className="close"
                    src={CLOSE_MOBILE_ICON}
                    alt="Close Icon"
                  />
                </s.CollapseButton>
              </s.TopButtonWrapper>

              <TopInfo isCollapsed={true} onOpen={() => collapseSidebar()} />
              <MenuComponent />
            </s.SideBarContainer>
          </s.SidebarBG>
        </mediaQuery.Mobile>
      )}

      <mediaQuery.Default>
        <Sidebar
          defaultCollapsed={true}
          backgroundColor={themes[theme].sidebar.backgroundColor}
          rootStyles={{
            ...themes[theme].sidebar,
          }}
        >
          <s.SideWrapper>
            {collapsed ? (
              <s.CollapseButton
                collapsed={collapsed}
                onClick={() => collapseSidebar()}
                data-testid="blocks-sidenav-sidenav-collapse-hamburger-open"
              >
                <img
                  className="hamburger"
                  src={HAMBURGER_ICON}
                  alt="hamburger Icon"
                />
              </s.CollapseButton>
            ) : (
              <s.CollapseButton
                onClick={() => collapseSidebar()}
                data-testid="blocks-sidenav-sidenav-collapse-close-open"
              >
                <img className="close" src={COLLAPSE_ICON} alt="Close Icon" />
              </s.CollapseButton>
            )}

            <TopInfo isCollapsed={!collapsed} />
            <MenuComponent />
            {process.env.REACT_APP_DATADOG_ENV === "development" && (
              <s.StompStatus status={connected} />
            )}
            {/* <s.UserInfo>
               <s.SidebarLevel
                 level={account.accountLevel}
                 isCollapsed={!collapsed}
               >
                 {account.accountLevel}
               </s.SidebarLevel>
              </s.UserInfo> */}
          </s.SideWrapper>
        </Sidebar>
      </mediaQuery.Default>
    </>
  );
}

export default SideNavBar;
